/**
 * Ingelogd op `/inloggen` (MA-44). Met een geldige `?terug=` (alleen mamimap.nl en zijn
 * subdomeinen, zie lib/terug.ts) gaat de browser daarheen, bijvoorbeeld naar het venster van
 * de vanger. Zonder, of met een adres buiten MamiMap: gewoon de kaart.
 *
 * Stuurt het venster je binnen een halve minuut weer hierheen, dan komt de inlog daar niet
 * aan. Dan niet eindeloos heen en weer, maar zeggen wat er is.
 */
import { useEffect, useState } from 'react';
import { navigeer, useZoekParams } from '@/lib/router';
import { magTerugsturen, veiligTerug } from '@/lib/terug';

/** `naar`: het begin van de werkruimte waar dit account opent (MA-72). */
export function NaInloggen({ naar }: { naar: string }) {
  const terug = veiligTerug(useZoekParams().get('terug'));
  const [vastgelopen, zetVastgelopen] = useState(false);

  useEffect(() => {
    if (!terug) {
      navigeer(naar, { vervang: true });
      return;
    }
    if (magTerugsturen(terug)) {
      window.location.replace(terug);
    } else {
      zetVastgelopen(true);
    }
  }, [terug, naar]);

  if (!vastgelopen || !terug) return <div className="h-full bg-paper" />;

  return (
    <div className="flex h-full items-center justify-center bg-paper px-6">
      <div className="w-[320px]">
        <h1 className="kop text-[20px]">MamiMap</h1>
        <div className="mt-3 mb-4 h-px bg-line-strong" />
        <p className="text-[13px] text-ink-soft">
          Je bent ingelogd, maar {new URL(terug).hostname} herkent die inlog nog niet en stuurde je
          terug.
        </p>
        <p className="mt-1.5 text-[12px] text-muted">
          Log uit en weer in, of probeer het over een halve minuut opnieuw.
        </p>
        <div className="mt-4 flex gap-3">
          <a className="knop-stil" href={terug}>
            Opnieuw proberen
          </a>
          <a className="knop-stil" href={naar}>
            Naar de kaart
          </a>
        </div>
      </div>
    </div>
  );
}
